class EditContractInfoModalController {
  constructor($scope, $uibModalInstance, $rootScope, $http, $timeout, contractName, shortName, customerId, customers, contractUrl) {
    "ngInject";
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.$timeout = $timeout;
    this.contractUrl = contractUrl;
    
    // Debug: Log received values
    console.log('EditContractInfoModal - Received values:', {
      contractName,
      shortName,
      customerId,
      customersLength: customers ? customers.length : 0,
      contractUrl
    });
    
    // Initialize form values immediately
    this.contractName = contractName || '';
    this.shortName = shortName || '';
    
    // Store original values for change detection
    this.originalContractName = contractName || '';
    this.originalShortName = shortName || '';
    this.originalCustomerId = customerId;
    
    // Initialize customer list
    this.customers = customers || [];
    this.selectedCustomer = null;
    
    if (customerId && this.customers && this.customers.length > 0) {
      this.selectedCustomer = this.customers.find(c => c.id === customerId);
    }
    
    // Use $timeout as a backup to ensure values are set if they weren't picked up initially
    this.$timeout(() => {
      // Re-set form values to ensure they're bound
      if (!this.contractName && contractName) {
        this.contractName = contractName;
      }
      if (!this.shortName && shortName) {
        this.shortName = shortName;
      }
      
      // Re-set customer if not already set
      if (!this.selectedCustomer && customerId && this.customers && this.customers.length > 0) {
        this.selectedCustomer = this.customers.find(c => c.id === customerId);
      }
    }, 100);
  }
  
  onCustomerSelected(customer) {
    this.selectedCustomer = customer;
  }
  
  hasChanges() {
    const nameChanged = this.contractName !== this.originalContractName;
    const shortNameChanged = this.shortName !== this.originalShortName;
    const customerChanged = this.selectedCustomer && this.selectedCustomer.id !== this.originalCustomerId;
    
    return nameChanged || shortNameChanged || customerChanged;
  }
  
  save() {
    if (!this.hasChanges()) {
      this.$uibModalInstance.dismiss();
      return;
    }
    
    const updates = {};
    let updatePromises = [];
    
    // Update contract name if changed
    if (this.contractName !== this.originalContractName) {
      updates.contractName = this.contractName;
    }
    
    // Update short name if changed
    if (this.shortName !== this.originalShortName) {
      updates.shortName = this.shortName;
    }
    
    // Update customer if changed
    if (this.selectedCustomer && this.selectedCustomer.id !== this.originalCustomerId) {
      updates.customerId = this.selectedCustomer.id;
    }
    
    // Send updates
    if (Object.keys(updates).length > 0) {
      this.$http.patch(this.contractUrl, updates, { withCredentials: true })
        .then(() => {
          // Return updated values
          this.$uibModalInstance.close({
            contractName: this.contractName,
            shortName: this.shortName,
            customerId: this.selectedCustomer ? this.selectedCustomer.id : this.originalCustomerId,
            customerName: this.selectedCustomer ? this.selectedCustomer.name : null
          });
        })
        .catch((error) => {
          console.error('Error updating contract information:', error);
          // Could show error message here
        });
    } else {
      this.$uibModalInstance.dismiss();
    }
  }
  
  cancel() {
    this.$uibModalInstance.dismiss();
  }
}

export default EditContractInfoModalController;




// WEBPACK FOOTER //
// ./client/common/modals/editContractInfoModal/editContractInfoModal.controller.js